// extracted by mini-css-extract-plugin
export default {"appleform":"SuspendedLanding_appleform__XXEaC","confirmBold":"SuspendedLanding_confirmBold__yL-eQ"};